import type { ButtonHTMLAttributes } from 'react'
import { cls } from './cls'

const BASE = 'rounded-full border px-2.5 py-1 text-xs transition-colors cursor-pointer ' +
  'disabled:opacity-35 disabled:cursor-not-allowed'

const STATE = {
  on: 'border-ink-1000 bg-ink-1000 font-semibold text-white',
  off: 'border-ink-200 bg-transparent text-ink-500 hover:border-ink-1000 hover:text-ink-1000',
}

export interface ChipProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  selected?: boolean
}

/** A selectable pill — filter chips, segmented choices. */
export function Chip({ selected = false, type = 'button', className, ...rest }: ChipProps) {
  return (
    <button
      type={type}
      aria-pressed={selected}
      className={cls(BASE, selected ? STATE.on : STATE.off, className)}
      {...rest}
    />
  )
}
